<template>
  <Layout>
    <Sider ref="side1" hide-trigger collapsible :collapsed-width="78" v-model="isCollapsed">
      <Menu theme="dark" width="auto" :active-name="active_name" ref="side_menu" :open-names="open_name">
        <MenuItem name="home" to="/home">
        <Icon type="ios-home"></Icon>首页</MenuItem>
        <Submenu name='agent' v-show="menuShow('agent')">
          <template slot="title">
            <Icon type="ios-globe-outline" />代理商管理
          </template>
          <!--		        <MenuItem name="alist" to="/agent/alist" v-show="menuShow('agent/alist')">代理商列表</MenuItem>-->
          <MenuItem name="adminlist" to="/agent/adminlist" v-show="menuShow('agent/adminlist')">管理员列表</MenuItem>
        </Submenu>

        <Submenu name='channel' v-show="menuShow('channel')">
          <template slot="title">
            <Icon type="ios-aperture-outline" />渠道管理
          </template>
          <MenuItem name="channelList" to="/channel/channelList" v-show="menuShow('channel/channelList')">渠道列表
          </MenuItem>
        </Submenu>

        <Submenu name='goods' v-show="menuShow('goods')">
          <template slot="title">
            <Icon type="ios-basket-outline" />商品管理
          </template>
          <MenuItem name="goodsList" to="/goods/goodsList" v-show="menuShow('goods/goodsList')">单品列表</MenuItem>
          <MenuItem name="goodsGroupList" to="/goods/goodsGroupList" v-show="menuShow('goods/goodsGroupList')">产品套餐列表
          </MenuItem>
          <MenuItem name="goodsCompute" to="/goods/goodsCompute" v-show="menuShow('goods/goodsCompute')">商品算力</MenuItem>
        </Submenu>

        <Submenu name='user' v-show="menuShow('user')">
          <template slot="title">
            <Icon type="ios-people-outline"></Icon>用户管理
          </template>
          <MenuItem name="list" to="/user/list" v-show="menuShow('user/list')">用户列表</MenuItem>
          <MenuItem name="nfc" to="/user/nfc" v-show="menuShow('user/nfc')">用户NFC</MenuItem>
          <MenuItem name="r" to="/user/rt" v-show="menuShow('user/rt')">实时并发</MenuItem>
        </Submenu>

        <Submenu name='aimenu' v-show="menuShow('aimenu')">
          <template slot="title">
            <Icon type="ios-contact" />1号AI
          </template>
          <MenuItem name="aiFigureFoleList" to="/aimenu/aiFigureFoleList" v-show="menuShow('aimenu/aiFigureFoleList')">
          分身管理
          </MenuItem>
          <MenuItem name="aiAnalysis" to="/aimenu/aiAnalysis" v-show="menuShow('aimenu/aiAnalysis')">
            智能体分析
          </MenuItem>
          <MenuItem name="aiSubject" to="/aimenu/aiTopic" v-show="menuShow('aimenu/aiTopic')">
            智能体选题
          </MenuItem>
          <MenuItem name="aiTopic" to="/aimenu/aiFrame" v-show="menuShow('aimenu/aiFrame')">
            智能体框架
          </MenuItem>
        </Submenu>

        <Submenu name='figure' v-show="menuShow('figure')">
          <template slot="title">
            <Icon type="ios-person-outline" />人物管理
          </template>
          <MenuItem name="agentShareList" to="/figure/agentShareList" v-show="menuShow('figure/agentShareList')">审核列表</MenuItem>
          <MenuItem name="shareList" to="/figure/shareList" v-show="menuShow('figure/shareList')">数字人库</MenuItem>
          <MenuItem name="shelfList" to="/figure/shelfList" v-show="menuShow('figure/shelfList')">数字人上架</MenuItem>
          <MenuItem name="train" to="/figure/train" v-show="menuShow('figure/train')">数字人训练</MenuItem>
<!--          <MenuItem name="trainVideoList" to="/figure/trainVideoList" v-show="menuShow('figure/train')">Demo剪辑上传</MenuItem>-->
          <!--<MenuItem name="photoFigureList" to="/figure/photoFigureList" v-show="menuShow('figure/photoFigureList')">照片数字人列表</MenuItem>-->
          <MenuItem name="aiBrainList" to="/figure/aiBrainList" v-show="menuShow('figure/aiBrainList')">AI大脑</MenuItem>
          <MenuItem name="langList" to="/figure/langList" v-show="menuShow('figure/langList')">发音人列表</MenuItem>
          <MenuItem name="xiaoweiList" to="/figure/xiaoweiList" v-show="menuShow('figure/xiaoweiList')">小微声音列表</MenuItem>
          <MenuItem name="xiaoweiFigureList" to="/figure/xiaoweiFigureList"  v-show="menuShow('figure/xiaoweiFigureList')">小微人物列表</MenuItem>
          <MenuItem name="huoshanList" to="/figure/huoshanList" v-show="menuShow('figure/huoshanList')">声音复刻列表</MenuItem>
          <MenuItem name="huoshanSpeakerList" to="/figure/huoshanSpeakerList"  v-show="menuShow('figure/huoshanSpeakerList')"> 火山音色列表</MenuItem>
          <MenuItem name="lingdongList" to="/figure/lingdongList"  v-show="menuShow('figure/lingdongList')">灵动人物列表</MenuItem>
<!--          <MenuItem name="huanlianVideo" to="/figure/huanlianVideo" v-show="menuShow('figure/huanlianVideo')">人脸融合-视频素材</MenuItem>-->
          <!-- <MenuItem name="huanlianPic" to="/figure/huanlianPic" v-show="menuShow('huanlianPic')">人脸融合-图片视频</MenuItem>
        <MenuItem name="huanlianTask" to="/figure/huanlianTask" v-show="menuShow('huanlianTask')">人脸融合-融合任务</MenuItem>
        <MenuItem name="huanlianMerge" to="/figure/huanlianMerge" v-show="menuShow('huanlianMerge')">人脸融合-合并任务</MenuItem> -->
        </Submenu>
        
        <Submenu name='video' v-show="menuShow('video')">
          <template slot="title">
            <Icon type="ios-ionitron-outline" />视频列表
          </template>
          <MenuItem name="vlist" to="/video/vlist" v-show="menuShow('video/vlist')">视频任务</MenuItem>
          <MenuItem name="videQueue" to="/video/videoQueue" v-show="menuShow('video/videoQueue')">视频队列</MenuItem>
          <MenuItem name="mcJob" to="/video/mcJob" v-show="menuShow('video/mcJob')">MC任务</MenuItem>
        </Submenu>
        <Submenu name='talk' v-show="menuShow('talk')">
          <template slot="title">
            <Icon type="ios-text-outline" />对话管理
          </template>
          <MenuItem name="talkList" to="/talk/talkList" v-show="menuShow('talk/talkList')">对话列表</MenuItem>
          <MenuItem name="preGenList" to="/talk/preGenList" v-show="menuShow('talk/preGenList')">预生成视频</MenuItem>
        </Submenu>
        <Submenu name='pay' v-show="menuShow('pay')">
          <template slot="title">
            <Icon type="ios-cart-outline" />支付管理
          </template>
          <MenuItem name="plist" to="/pay/plist" v-show="menuShow('pay/plist')">订单列表</MenuItem>
          <MenuItem name="alist" to="/pay/alist" v-show="menuShow('pay/alist')">代理商订单列表</MenuItem>
          <MenuItem name="platformList" to="/pay/platformList" v-show="menuShow('pay/platformList')">云市场订单</MenuItem>
        </Submenu>
        <Submenu name='common' v-show="menuShow('common')">
          <template slot="title">
            <Icon type="ios-hammer-outline" />通用设置
          </template>
          <MenuItem name="setList" to="/common/setList" v-show="menuShow('common/setList')">设置列表</MenuItem>
          <MenuItem name="appVersion" to="/common/appVersion" v-show="menuShow('common/appVersion')">版本上传</MenuItem>
          <MenuItem name="tagList" to="/common/tagList" v-show="menuShow('common/tagList')">标签列表</MenuItem>
          <MenuItem name="monitor" to="/common/monitor" v-show="menuShow('common/monitor')">系统监控</MenuItem>
          <MenuItem name="openList" to="/common/openList" v-show="menuShow('common/openList')">开放平台</MenuItem>
          <MenuItem name="xiaoweiStudioList" to="/common/xiaoweiStudioList" v-show="menuShow('common/xiaoweiStudioList')">小薇直播间列表</MenuItem>
          <MenuItem name="yuyi" to="/common/yuyi" v-show="menuShow('common/yuyi')">工具</MenuItem>
          <MenuItem name="noticeList" to="/common/noticeList" v-show="menuShow('common/noticeList')">消息通知</MenuItem>
          <MenuItem name="awakening" to="/common/awakening" v-show="menuShow('common/awakening')">APP唤醒词</MenuItem>
         <MenuItem name="couponList" to="/common/couponList" v-show="menuShow('common/couponList')">优惠券</MenuItem>
		  <MenuItem name="couponCodeList" to="/common/couponCodeList" v-show="menuShow('common/couponCodeList')">兑换卡/优惠码</MenuItem>
        </Submenu>
        <Submenu name='material' v-show="menuShow('material')">
          <template slot="title">
            <Icon type="ios-folder-open-outline" />运营管理
          </template>
          <MenuItem name="adManage" to="/material/adManage" v-show="menuShow('material/adManage')">广告位管理</MenuItem>
          <MenuItem name="unitList" to="/material/unitList" v-show="menuShow('material/unitList')">背景组件</MenuItem>
          <MenuItem name="preTemplate" to="/material/preTemplate" v-show="menuShow('material/preTemplate')">预设模板
          </MenuItem>
          <MenuItem name="studioList" to="/material/studioList" v-show="menuShow('material/studioList')">模板列表</MenuItem>
          <MenuItem name="voiceAnalysis" to="/material/voiceAnalysis" v-show="menuShow('material/voiceAnalysis')">语音识别
          </MenuItem>
          <MenuItem name="tiezhiList" to="/material/tiezhiList" v-show="menuShow('material/tiezhiList')">贴纸列表</MenuItem>
          <MenuItem name="hotRank" to="/material/hotRank" v-show="menuShow('material/hotRank')">热门排行榜</MenuItem>
          <MenuItem name="hotList" to="/material/hotList" v-show="menuShow('material/hotList')">热点榜单</MenuItem>
        </Submenu>
        <Submenu name='studio' v-show="menuShow('studio')">
          <template slot="title">
            <Icon type="ios-hammer-outline" />内容安全管理
          </template>
          <MenuItem name="setList" to="/studio/sensitiveWordsList" v-show="menuShow('studio/sensitiveWordsList')">敏感词列表
          </MenuItem>
        </Submenu>
      </Menu>
    </Sider>

    <Layout>
      <Header :style="{ padding: 0 }" class="layout-header-bar">
        <span :style="{ float: 'left', color: '#fff', align: 'center', }">
          <Icon @click.native="collapsedSider" :class="rotateIcon" :style="{ margin: '0 20px' }" type="md-menu" size="24"></Icon>
          <font style="font-size: 20px;font-weight: bold;">风平IP智造 | 星梦</font>
        </span>
        <Menu mode="horizontal" theme="dark" active-name="1" :style="{ float: 'right' }">
          <template v-if="account != ''">
            <MenuItem name="account">
            {{ account }}
            </MenuItem>
            <MenuItem name="updatepwd" to="/updatepwd"> 修改密码 </MenuItem>
            <Button @click="logout"> 退出 </Button>
          </template>
          <template v-else>
            <MenuItem name="tag" to="/login"> 登录 </MenuItem>
          </template>
        </Menu>
      </Header>
      
      <router-view class="layout-center" />
    </Layout>
  </Layout>
</template>

<script>
export default {
  data() {
    return {
      isCollapsed: false,
      active_name: 'home',
      open_name: [],
      account: localStorage.getItem("account"),
      action_auth: JSON.parse(localStorage.getItem('action_auth')),
      is_super: localStorage.getItem("is_super"),
      rolesRoot: [],
      rolesRes: [],
    };
  },
  mounted: function () {
    this.rolesRoot["none"] = [];
    var menu = this.$route.path.slice(1).split('/');
    this.open_name.push(menu[0]);
    this.active_name = menu[1];

    this.$nextTick(() => {
      this.$refs.side_menu.updateOpened();
      this.$refs.side_menu.updateActiveName()
    })

  },
  computed: {
    rotateIcon() {
      return [
        'menu-icon',
        this.isCollapsed ? 'rotate-icon' : ''
      ];
    },
    menuitemClasses() {
      return [
        'menu-item',
        this.isCollapsed ? 'collapsed-menu' : ''
      ]
    }
  },
  methods: {
    collapsedSider() {
      this.$refs.side1.toggleCollapse();
    },
    logout() {
      this.http
        .post("/admin/auth/logout", {})
        .then((response) => {
          let data = response.data;
          console.log(data, 'response===>')
          if (data.code !== 0) {
            // alert(data.message);
          } else {
            this.$store.commit("SET_ACCOUNT", "");
            this.$store.commit("SET_TOKEN", "");
            localStorage.removeItem("account");
            localStorage.removeItem("token");
            localStorage.removeItem("action_auth");
            clearInterval(this.timer);
            this.$router.push({ path: "/login" });
          }
        })
        .catch(() => {
          this.$Message.error("网络错误");
        });
    },
    resource() {

    },
    menuShow(menuname) {
      // console.log(menuname)
      //var menu = this.$route.path.slice(1).split('/');
      // return true; 
      if (this.is_super == 1) {
        return true;
      } else {
        for (let key in this.action_auth) {
          if (menuname == key) {
            return true;
          }
        }
      }
      return false;
    }
  },
};
</script>

<style scoped>

.layout-center {
  padding: 10px;
}

.layout {
  border: 1px solid #d7dde4;
  background: #f5f7f9;
  position: relative;
  border-radius: 4px;
  overflow: hidden;
}

.layout-header-bar {
  box-shadow: 0 1px 1px rgba(0, 0, 0, .1);
}

.layout-logo-left {
  width: 90%;
  height: 30px;
  background: #5b6270;
  border-radius: 3px;
  margin: 15px auto;
}

.menu-icon {
  transition: all .3s;
  color: #fff;
}

.rotate-icon {
  transform: rotate(-90deg);
}

.menu-item span {
  display: inline-block;
  overflow: hidden;
  width: 69px;
  text-overflow: ellipsis;
  white-space: nowrap;
  vertical-align: bottom;
  transition: width .2s ease .2s;
}

.menu-item i {
  transform: translateX(0px);
  transition: font-size .2s ease, transform .2s ease;
  vertical-align: middle;
  font-size: 16px;
}

.collapsed-menu span {
  width: 0px;
  transition: width .2s ease;
}

.collapsed-menu i {
  transform: translateX(5px);
  transition: font-size .2s ease .2s, transform .2s ease .2s;
  vertical-align: middle;
  font-size: 22px;
}
</style>